module.exports = __webpack_public_path__ + "img/SamsungGalaxyNote20.139ac867.png";